import { render, staticRenderFns } from "./TiposProducto.vue?vue&type=template&id=2efef7c6&"
import script from "./TiposProducto.vue?vue&type=script&lang=js&"
export * from "./TiposProducto.vue?vue&type=script&lang=js&"
import style0 from "./TiposProducto.vue?vue&type=style&index=0&id=2efef7c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports